import { Chart, registerables } from 'chart.js';
import { useEffect } from 'react';

/**
 * Chart Base Component
 * @param {{type:*, data:*, options:*, plugins?:*}} param0
 * @returns
 */
export default function ChartBase({ type, data, options, plugins = [] }) {
  Chart.register(...registerables);

  const chartID = 'chart' + Math.random();

  useEffect(() => {
    // @ts-ignore
    const ctx = document.getElementById(chartID).getContext('2d');
    // @ts-ignore
    const chart = new Chart(ctx, {
      type: type,
      data: data,
      options: options,
      plugins: [...plugins],
    });
    return () => chart.destroy();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  return (
    <div className="chartjs-wrapper">
      <canvas id={chartID} className="chartjs"></canvas>
    </div>
  );
}
